import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function WPQTPageHeader({ children, description = null, icon = null, }) {
    return (_jsxs("div", { className: "wpqt-mb-6 wpqt-inline-grid wpqt-grid-cols-[auto_auto] wpqt-items-center wpqt-gap-2", children: [_jsxs("div", { children: [_jsx("h1", { children: children }), description && _jsx("div", { children: description })] }), _jsx("div", { children: icon })] }));
}
export { WPQTPageHeader };
